var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,attrs:{"id":"mobility-text"}},[(_vm.$store.state.showDetailedInfo)?_c('span',_vm._l((_vm.copyData[_vm.year].copy),function(copy){return _c('p',{key:copy,domProps:{"innerHTML":_vm._s(copy)}})}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }